<template>
  <loader :is-loading="loading" color="primary">
  </loader>
</template>
<script>
import { Authentication } from '@icabbi/vue-authentication';
import { mapGetters } from 'vuex';
import environment from '@/environment';
import { RoutePath } from '@/routing/routePath';
import { bookingChannelComputed } from '../../mixins/bookingChannel.mixins';

export default {
  name: 'OAuthLogoutView',
  mixins: [bookingChannelComputed],
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    if (environment.isInMockApiMode()) {
      await this.$store.dispatch('authManager/mockLogout', {
        loginUrl: RoutePath.GET_STARTED_PATH,
      });
    } else {
      await this.$store.dispatch('authentication/revokeToken', { token: this.token, client_id: this.clientId });
      await Authentication(this.$store).logout(this.idToken, this.postLogoutUrl);
    }
  },
  computed: {
    ...mapGetters({
      token: 'authentication/token',
      idToken: 'authentication/idToken',
      postLogoutUrl: 'bookingChannel/postLogoutUrl',
      clientId: 'bookingChannel/oidcClientId',
    }),
  },
};
</script>

<style scoped>
</style>
